var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading-div",class:{ mask: _vm.mask },style:({ height: (_vm.height + "px") })}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }